'use strict';

class GroupsListController {
  constructor($scope,
              $rootScope,
              $q,
              $timeout,
              $filter,
              $state,
              utils,
              PermissionsService,
              TagsService) {

    // #region Define fields

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

    $scope.loading = false;
    $scope.groupsPage = {};
    let $groupsPage = $scope.groupsPage;
    $groupsPage.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $groupsPage.addOrEdit = 'add';
    $groupsPage.updateBtnDesc = $t('groups.btn.new-desc');
    $groupsPage.updateBtnText = $t('btn.add');
    $groupsPage.inputPlaceholder = $t('groups.btn.new');
    $groupsPage.searchVal = '';
    $groupsPage.selectedGroup = {};
    $groupsPage.defaultGroupType = '0';
    $groupsPage.currentGroups = [];
    $groupsPage.childGroups = [];
    $groupsPage.groupTypes = [
      {
        'name': $t('groups.types.0'),
        'value': '0'
      }, {
        'name': $t('groups.types.1'),
        'value': '1'
      }
    ];

    let filterKey = 'Filter-Groups-' + $groupsPage.orgInfo.id;
    $scope.cacheFilter = false;

    // #endregion

    angular.extend($scope, {
      initGroupTypeDropDown: initGroupTypeDropDown,
      createGroup: createGroup,
      showLocations: showLocations,

      // Filter
      initFilterFromCache: initFilterFromCache,
      filterGroups: filterGroups,
      search: search,

      canViewGroupLocations: canViewGroupLocations,
    });

    init();

    // #region Methods

    function init() {
      $scope.$watchGroup(['cacheFilter', 'groupsPage.searchVal'], function() {
        // We save filter only after it was applied
        // saveFilter();
      });

      initFilterFromCache();
      $scope.loading = true;
      return getGroups()
        .then(() => $scope.loading = false, () => $scope.loading = false);
    }

    function saveFilter() {
      if ($scope.cacheFilter) { // Cache filter
        let params = {
          searchVal: $groupsPage.searchVal
        };
        utils.setStorageItem(filterKey, params);
      } else { // Remove filter
        utils.removeStorageItem(filterKey);
      }
    }

    function initFilterFromCache() {
      $scope.cacheFilter = true;
      let params = utils.getStorageItem(filterKey);
      if (params) {
        $groupsPage.searchVal = params.searchVal;
      }
    }

    function search() {
      saveFilter();
    }

    function initGroupTypeDropDown() {
      $timeout(function() {
        const ddControl = $('#dropdown-group-type');
        ddControl.dropdown({
          action: 'activate',
          placeholder: 'auto',
          message: {
            noResults: $t('prompt.not-found')
          },
          onChange: (value, text, $selectedItem) => {
            if (!$selectedItem) {
              return;
            }
            $groupsPage.selectedGroup.type = $selectedItem.data('value');
            utils.ngDigest($scope);
          }
        });
        ddControl.dropdown('set selected', $groupsPage.defaultGroupType);
      }, 200);
    }

    function getGroups() {
      TagsService.getPopularTags.clearEntireCache();

      let tagType = 2; // Location tags
      let tagCategory = 2; // Groups

      return TagsService.getPopularTags($groupsPage.orgInfo.id, tagType, tagCategory)
        .then(data => {
          $groupsPage.currentGroups = (data && data.tags) ? data.tags : [];
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
          return $q.reject(err);
        });
    }

    /**
     * Filter groups
     * @param group
     * @param index
     * @param array
     * @returns {boolean}
     */
    function filterGroups(group, index, array) {
      if (!$groupsPage.searchVal || !array || array.length === 0) {
        return true;
      }
      if (!group || !group.tag) {
        return false;
      }
      return group.tag.toLowerCase().indexOf($groupsPage.searchVal.toLowerCase()) !== -1;
    }

    function canViewGroupLocations() {
      return PermissionsService.canIViewLocationList();
    }

    function showLocations(group) {
      if (!canViewGroupLocations()) {
        return;
      }
      if (!group || !group.total) {
        return;
      }
      utils.setStorageItem('Filter-Locations-' + $groupsPage.orgInfo.id, { groupTag: group.tag });
      $state.go('main.locations.list');
      $rootScope.$emit('refreshChooseMenuEvent', 'locations');
    }

    function createGroup() {
      // TODO: Some implementation needed
    }

    // #endregion

  }
}

export default angular
  .module('main.groupsList.controller', [])
  .controller('GroupsListController', GroupsListController)
  .name;
